import * as React from 'react'

import { Visit } from 'app/fieldapp/store/visits'

import { VisitInspectionTimerControlsContainer } from '../VisitDetail/components/VisitInspectionTimerControls/VisitInspectionTimerControls.container'
import { InspectionChecklistContextWrapper } from './context/VisitInspectionChecklist.context'
import { VisitInspectionChecklist } from './VisitInspectionChecklist'

export type VisitInspectionChecklistContainerProps = {
  visit: Visit
}

export const VisitInspectionChecklistContainer: React.FC<VisitInspectionChecklistContainerProps> =
  React.memo(({ visit }) => {
    return (
      <InspectionChecklistContextWrapper visit={visit}>
        {!!visit.startedAt && (
          <VisitInspectionTimerControlsContainer visit={visit} />
        )}
        <VisitInspectionChecklist isLoadingVisit={false} />
      </InspectionChecklistContextWrapper>
    )
  })
